<template lang="html">
	<div class="personal-container">
		<van-row>
			<van-col span="24">
				<div class="fix userinfo-box">
					<div class="fl personal-img-box">
						<van-image class="personal-img" fit="cover" :src="avatar" />
					</div>
					<div class="fl userinfo">
						<div>
							<p class="nickname">{{nickname}}</p>
							<p class="signature">{{bio}}</p>
						</div>
					</div>
				</div>
			</van-col>
		</van-row>
		<van-cell-group>
			<van-cell title="个人资料" is-link @click="goUserData()" />
			<van-cell title="我的优惠券" is-link @click="goUserCoupons()" />
		<!-- 	<van-cell title="关于我们" is-link @click="goAboutUs()" /> -->
		</van-cell-group>
		<footer-nav></footer-nav>
	</div>
</template>

<script>
	import FooterNav from "../../components/footer.vue";
	export default{
		components:{
			FooterNav
		},
		data(){
			return{
				nickname: '',
				bio: '',
				avatar: ''
			}
		},
		created(){
			let that = this;
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('token', localStorage.getItem('token'));
			that.$axios.post('http://sls.zhishen.net.cn/api/User/getUserInfo', formdata)
			.then(function (res) {
				that.nickname = res.data.userinfo.nickname
				that.bio = res.data.userinfo.bio
				that.avatar = res.data.userinfo.avatar
			})
			.catch(function (error) {
				console.log(error);
			});
			document.title = "我的"
		},
		methods:{
			//个人资料
			goUserData(){
				this.$router.push({path: '/userdata'});
			},
			//关于我们
			goAboutUs(){
				this.$router.push({path: '/aboutus'});
			},
			//我的优惠券
			goUserCoupons(){
				this.$router.push({path: '/myCoupons'});
			}
		}
	}
</script>

<style lang="css" scoped>
	.personal-container{width: 100%;height: 100%;background: #f5f7fa;position: fixed;top: 0;}
	.van-row,.van-col,.userinfo{height: 15.74vw;}
	.van-row{background: #fff;padding: 4.8vw 5.34vw 5.34vw;}
	.van-col{text-align: left;}
	.personal-img-box{margin-right: 4vw;}
	.personal-img-box,.personal-img{width: 15.74vw;height: 15.74vw;}
	.personal-img .van-image__img{border-radius: 50%;}
	.userinfo{width: 69.58vw;display: flex;align-items: center;}
	.nickname{color: #484848;font-size: 4.8vw;line-height: 4.8vw;font-weight: bold;}
	.signature,.van-cell{font-size: 4vw;}
	.signature{color: #999;line-height: 4.54vw;margin-top: 2.67vw;word-break:break-all;word-wrap:break-word}
	.van-cell-group{margin-top: 10px;}
	.van-cell{padding: 4.8vw 5.34vw;color: #696969;}
	.van-cell-group .van-cell:first-child .van-cell__title{background: url(../../../static/images/gerenziliao.png) no-repeat left;background-size: 4.54vw 4.54vw;}
	.van-cell-group .van-cell:last-child .van-cell__title{background: url(../../../static/images/wodeyouhuiquan.png) no-repeat left;background-size: 4.54vw 4.8vw;}
	.van-cell-group .van-cell:first-child .van-cell__title,.van-cell-group .van-cell:last-child .van-cell__title{padding-left: 9.06vw;}
	.van-cell__title{text-align: left;}
	.van-cell:not(:last-child)::after{left: 5.34vw;right: 5.34vw;}
	.van-cell__right-icon{color: #b4b4b4;}
</style>



// WEBPACK FOOTER //
// src/view/personal/index.vue